export default __webpack_public_path__ + "static/media/folajuNcake.b5ce0f8a.jpeg";